// extracted by mini-css-extract-plugin
export default {"gallery":"c-n_fu","gallery__header":"c-n_fv","gallery__thumbs":"c-n_fw"};